if (!customElements.get('sheworks-collection')) {
  customElements.define('sheworks-collection', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        if (target.hasAttribute('data-open-filters')) this.querySelector('.sw-collection__filters').showModal();
        if (target.hasAttribute('data-close-dialog')) target.closest('dialog').close();
        if (target.hasAttribute('data-columns')) {
          this.dataset.view = target.dataset.columns;
          this.querySelectorAll('[data-columns]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
        }
        if (target.hasAttribute('data-quick-view')) {
          const template = target.closest('article').querySelector('template');
          const dialog = this.querySelector('.sw-collection__preview');
          dialog.querySelector('[data-preview-content]').replaceChildren(template.content.cloneNode(true));
          dialog.showModal();
        }
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
  });
}
